/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online age calculator. Enter your date of birth to see your exact age in years, months and days, plus total days, weeks and hours and your next birthday.`)
};

const es_age_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de edad en línea gratuita. Ingresa tu fecha de nacimiento para ver tu edad exacta en años, meses y días, más días totales, semanas y horas y tu próximo cumpleaños.`)
};

const de_age_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Altersrechner. Geben Sie Ihr Geburtsdatum ein, um Ihr genaues Alter in Jahren, Monaten und Tagen sowie Gesamttage, Wochen und Stunden und Ihren nächsten Geburtstag zu sehen.`)
};

const nl_age_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online leeftijdscalculator. Voer uw geboortedatum in om uw exacte leeftijd in jaren, maanden en dagen te zien, plus totale dagen, weken en uren en uw volgende verjaardag.`)
};

const fr_age_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrice d'âge en ligne gratuite. Entrez votre date de naissance pour voir votre âge exact en années, mois et jours, plus le nombre total de jours, semaines et heures et votre prochain anniversaire.`)
};

const it_age_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore dell'età online gratuito. Inserisci la tua data di nascita per vedere la tua età esatta in anni, mesi e giorni, più giorni, settimane e ore totali e il tuo prossimo compleanno.`)
};

const pt_br2_age_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de idade online grátis. Digite sua data de nascimento para ver sua idade exata em anos, meses e dias, além do total de dias, semanas e horas e seu próximo aniversário.`)
};

const pt_age_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de idade gratuita online. Introduza a sua data de nascimento para ver a sua idade exata em anos, meses e dias, mais o total de dias, semanas e horas e o seu próximo aniversário.`)
};

const ja_age_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンライン年齢計算機。生年月日を入力して、正確な年齢（年、月、日）と総日数、週数、時間、次の誕生日を確認してください。`)
};

const zh_age_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线年龄计算器。输入您的出生日期，即可查看以年、月、日表示的精确年龄，以及总天数、周数、小时数和下一个生日。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_meta_description", locale)
	if (locale === "en") return en_age_meta_description(inputs)
	if (locale === "es") return es_age_meta_description(inputs)
	if (locale === "de") return de_age_meta_description(inputs)
	if (locale === "nl") return nl_age_meta_description(inputs)
	if (locale === "fr") return fr_age_meta_description(inputs)
	if (locale === "it") return it_age_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_age_meta_description(inputs)
	if (locale === "pt") return pt_age_meta_description(inputs)
	if (locale === "ja") return ja_age_meta_description(inputs)
	return zh_age_meta_description(inputs)
};